import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setDataInicialReceitaDiaria: ['dataInicial'],
    setDataFinalReceitaDiaria: ['dataFinal'],
    setAdministracaoReceitaDiaria: ['administracao'],
    setRecursoReceitaDiaria: ['recurso'],
    setDestinacaoReceitaDiaria: ['destinacao'],
    setGrauReceitaDiaria: ['grau'],
    setCodigoReceitaReceitaDiaria: ['codigoReceita'],
    limpaFiltroReceitaDiaria: [],
    receberFiltroReceitaDiaria: ['filtroRecebido'],
})

const INITIAL_STATE = {
    dataInicial: '',
    dataFinal: '',
    administracao: [],
    recurso: [],
    destinacao: [],
    grau: { value: '5', label: '5' },
    codigoReceita: '',
}

const setDataInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataInicial: action.dataInicial }
}

const setDataFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataFinal: action.dataFinal }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}

const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}

const setGrau = (state = INITIAL_STATE, action) => {
    return { ...state, grau: action.grau }
}

const setCodigoReceita = (state = INITIAL_STATE, action) => {
    return { ...state, codigoReceita: action.codigoReceita }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    //Nunca deve apagar a sequencia, pois ela
    //é atribuida só na inicializacao do programa
    return { ...INITIAL_STATE, sequencia: state.sequencia }
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_DATA_INICIAL_RECEITA_DIARIA]: setDataInicial,
    [Types.SET_DATA_FINAL_RECEITA_DIARIA]: setDataFinal,
    [Types.SET_ADMINISTRACAO_RECEITA_DIARIA]: setAdministracao,
    [Types.SET_RECURSO_RECEITA_DIARIA]: setRecurso,
    [Types.SET_DESTINACAO_RECEITA_DIARIA]: setDestinacao,
    [Types.SET_GRAU_RECEITA_DIARIA]: setGrau,
    [Types.SET_CODIGO_RECEITA_RECEITA_DIARIA]: setCodigoReceita,
    [Types.LIMPA_FILTRO_RECEITA_DIARIA]: limpaFiltro,
    [Types.RECEBER_FILTRO_RECEITA_DIARIA]: receberFiltro,
})
